import React, { useState } from "react";
import { Banknote } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import api, { apiError } from "@/lib/api";
import { useLang } from "@/i18n";

/** Tussentijds afstorten naar de bank, met afstortingsbon. */
export default function InterimDeposit({ onDone }) {
  const { t } = useLang();
  const [bank, setBank] = useState(null);

  const open = async () => {
    let account = "";
    let inTill = "";
    try { account = (await api.get("/cash/deposits/last-account")).data.bank_account || ""; } catch { /* optioneel */ }
    try { inTill = String((await api.get("/cash/level")).data.in_till ?? ""); } catch { /* optioneel */ }
    setBank({ amount: inTill, by: "", note: "", bank_account: account });
  };

  const save = async () => {
    try {
      const { data } = await api.post("/cash/deposits", {
        amount: Number(bank.amount) || 0, by: bank.by, note: bank.note, bank_account: bank.bank_account,
      });
      setBank(null);
      if (onDone) await onDone();
      toast.success(t("saved"));
      window.open(`/print-afstorting?id=${data.id}`, "_blank");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  return (
    <>
      <Button variant="outline" onClick={open} data-testid="bank-deposit-button">
        <Banknote className="h-4 w-4 mr-1" />{t("cash_deposit_interim")}
      </Button>

      <Dialog open={!!bank} onOpenChange={(o) => !o && setBank(null)}>
        <DialogContent className="sm:max-w-md" data-testid="bank-deposit-dialog">
          <DialogHeader><DialogTitle className="font-display">{t("cash_deposit_interim")}</DialogTitle></DialogHeader>
          {bank && (
            <div className="space-y-3">
              <p className="text-sm text-muted-foreground">{t("cash_deposit_interim_hint")}</p>
              <div className="grid grid-cols-2 gap-3">
                <div className="space-y-1"><Label className="text-xs">{t("amount")}</Label>
                  <Input type="number" step="0.01" min="0" value={bank.amount} onChange={(e) => setBank({ ...bank, amount: e.target.value })} data-testid="bank-deposit-amount" /></div>
                <div className="space-y-1"><Label className="text-xs">{t("cash_deposit_by")}</Label>
                  <Input value={bank.by} placeholder={t("cash_deposit_by_ph")} onChange={(e) => setBank({ ...bank, by: e.target.value })} data-testid="bank-deposit-by" /></div>
                <div className="space-y-1 col-span-2"><Label className="text-xs">{t("cash_deposit_account")}</Label>
                  <Input value={bank.bank_account} onChange={(e) => setBank({ ...bank, bank_account: e.target.value })} data-testid="bank-deposit-account" /></div>
                <div className="space-y-1 col-span-2"><Label className="text-xs">{t("note")}</Label>
                  <Input value={bank.note} onChange={(e) => setBank({ ...bank, note: e.target.value })} data-testid="bank-deposit-note" /></div>
              </div>
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setBank(null)}>{t("cancel")}</Button>
            <Button onClick={save} disabled={!Number(bank?.amount)} data-testid="bank-deposit-save">{t("save")}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
